// Query params that are credentials. Telemetry must never carry their values.
export const SENSITIVE_QUERY_PARAMS: readonly string[] = ["token"];

const pattern = (params: readonly string[]) =>
	new RegExp(`([?&](?:${params.join("|")})=)[^&#]*`, "g");

export const redactSensitiveQueryParams = (
	value: string,
	params = SENSITIVE_QUERY_PARAMS,
): string => value.replace(pattern(params), "$1[Filtered]");

export const hasSensitiveQueryParam = (
	search: string,
	params = SENSITIVE_QUERY_PARAMS,
): boolean => pattern(params).test(search);
